/* collection-meteors.js — lluvia de meteoritos en el fondo de las páginas
   de categoría. Vanilla, sin librerías. Color desde --mtr-color / --mtr-rgb.
   - DPR-aware, se redimensiona con la ventana.
   - Se pausa cuando la pestaña está oculta.
   - prefers-reduced-motion: unos trazos estáticos, sin bucle.
   - Guard para no iniciarse dos veces. */
(function () {
  if (window.__mtrInit) return;
  window.__mtrInit = true;

  function rgb() {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--mtr-rgb').trim();
      var m = v.match(/(\d+)[\s,]+(\d+)[\s,]+(\d+)/);
      if (m) return m[1] + ',' + m[2] + ',' + m[3];
    } catch (e) {}
    return '122,117,110';
  }

  function init() {
    var canvas = document.querySelector('.mtr-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var C = rgb();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0;
    var meteors = [];
    var stars = [];
    var raf = null, last = 0, acc = 0;

    function resize() {
      w = canvas.clientWidth || window.innerWidth;
      h = canvas.clientHeight || window.innerHeight;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = [];
      var n = Math.round((w * h) / 26000);
      n = Math.max(20, Math.min(n, 90));
      for (var i = 0; i < n; i++) {
        var yy = Math.random() * h;
        // más brillo arriba (donde el fondo es oscuro), más tenue abajo
        var fade = 1 - Math.min(yy / (h * 0.6), 1);
        stars.push({ x: Math.random() * w, y: yy, r: Math.random() * 1.4 + 0.4, a: (Math.random() * 0.5 + 0.12) * (0.35 + 0.65 * fade) });
      }
    }

    function spawn() {
      var big = Math.random() < 0.18;
      var speed = (big ? 4.5 : 3) + Math.random() * 3;   /* 50% más lentos */
      var ang = (26 + Math.random() * 14) * Math.PI / 180; // hacia abajo-derecha
      meteors.push({
        x: Math.random() * w * 1.15 - w * 0.15,
        y: -40 - Math.random() * h * 0.35,
        vx: Math.cos(ang) * speed,
        vy: Math.sin(ang) * speed,
        len: (big ? 150 : 90) + Math.random() * 110,
        w: big ? 2.2 : 1.3,
        life: 1
      });
    }

    function drawStars() {
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        ctx.beginPath();
        ctx.fillStyle = 'rgba(' + C + ',' + s.a.toFixed(3) + ')';
        ctx.arc(s.x, s.y, s.r, 0, 6.2832);
        ctx.fill();
      }
    }

    function drawMeteor(m) {
      var tx = m.x - m.vx / Math.hypot(m.vx, m.vy) * m.len;
      var ty = m.y - m.vy / Math.hypot(m.vx, m.vy) * m.len;
      var g = ctx.createLinearGradient(m.x, m.y, tx, ty);
      g.addColorStop(0, 'rgba(255,255,255,' + (1 * m.life).toFixed(3) + ')');
      g.addColorStop(0.14, 'rgba(' + C + ',' + (0.95 * m.life).toFixed(3) + ')');
      g.addColorStop(0.55, 'rgba(' + C + ',' + (0.45 * m.life).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(' + C + ',0)');
      ctx.strokeStyle = g;
      ctx.lineWidth = m.w;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(m.x, m.y);
      ctx.lineTo(tx, ty);
      ctx.stroke();
      ctx.beginPath();
      ctx.fillStyle = 'rgba(255,255,255,' + (0.95 * m.life).toFixed(3) + ')';
      ctx.arc(m.x, m.y, m.w * 1.1, 0, 6.2832);
      ctx.fill();
    }

    function frame(dt) {
      ctx.clearRect(0, 0, w, h);
      drawStars();

      acc += dt;
      var interval = 190; // ms entre meteoritos
      while (acc > interval) { acc -= interval; if (meteors.length < 32) spawn(); }

      for (var i = meteors.length - 1; i >= 0; i--) {
        var m = meteors[i];
        m.x += m.vx; m.y += m.vy;
        if (m.y > h + 120 || m.x > w + 160) { m.life -= 0.04; }
        if (m.life <= 0) { meteors.splice(i, 1); continue; }
        drawMeteor(m);
      }
    }

    function loop(ts) {
      raf = requestAnimationFrame(loop);
      if (document.hidden) { last = ts; return; }
      var dt = ts - last;
      last = ts;
      if (dt > 60) dt = 60;
      if (dt < 1) dt = 16;
      frame(dt);
    }

    resize();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { dpr = Math.min(window.devicePixelRatio || 1, 2); resize(); if (reduce) staticFrame(); }, 180);
    });

    function staticFrame() {
      ctx.clearRect(0, 0, w, h);
      drawStars();
      for (var i = 0; i < 5; i++) {
        var mx = w * (0.15 + i * 0.18) + 40, my = h * (0.12 + i * 0.13);
        meteors = [{ x: mx, y: my, vx: 3, vy: 1.6, len: 120, w: 1.4, life: 0.8 }];
        drawMeteor(meteors[0]);
      }
      meteors = [];
    }

    if (reduce) {
      staticFrame();
    } else {
      // sembrar meteoritos ya visibles + primer dibujo (sin arranque en blanco)
      for (var k = 0; k < 9; k++) {
        spawn();
        var mm = meteors[meteors.length - 1];
        mm.x = Math.random() * w;
        mm.y = Math.random() * h * 0.9;
      }
      frame(16);
      last = performance.now();
      raf = requestAnimationFrame(loop);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) last = performance.now();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
